import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-call-recording',
  templateUrl: './call-recording.component.html',
  styleUrls: ['./call-recording.component.scss']
})
export class CallRecordingComponent implements OnInit {


  LoaderComponent: any = '';
  audioSrc:any;
  logID:any;

  constructor(public service: WebRequestService, private loginDataStore: Data, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private modalData: any,
  public dialogRef: MatDialogRef<CallRecordingComponent>
) { }

  ngOnInit() {

    this.logID = this.modalData.logId;
    this.audioSrc = this.modalData.audioSrc
  }

}
